var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('navigation'),_c('v-content',[(_vm.dashboard)?_c('dash'):_c('router-view')],1)],(!_vm.uid)?[_c('Login')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }